import axios from 'axios'
import { routesForgotpwd } from '../routes'
import { CANCEL,
    ON_NEXT,
    INIT,
    FETCH_DATA_SUCCESS,
    FETCH_DATA_ERROR,
    INIT_USER_APPS,
    INIT_USER_APPS_ERROR,
    INIT_USER_APPS_SUCCESS,
    SUBMIT_VERIFICATION_INIT,
    SUBMIT_VERIFICATION_INIT_SUCCESS,
    SUBMIT_VERIFICATION_INIT_ERROR,
    SEND_CHALLENGE,
    SEND_CHALLENGE_SUCCESS,
    SEND_CHALLENGE_ERROR,
    SESSION_TIMEOUT,
    SUBMIT_PASSWORD,
    SUBMIT_PASSWORD_SUCCESS,
    SUBMIT_PASSWORD_ERROR,
    RESEND_CODE,
    RESEND_CODE_SUCCESS,
    RESEND_CODE_ERROR,
    VERIFY_ACCOUNT_RECOVERY,
    VERIFY_ACCOUNT_RECOVERY_SUCCESS,
    VERIFY_ACCOUNT_RECOVERY_ERROR,
    GET_ACCOUNT_RECOVERY,
    GET_ACCOUNT_RECOVERY_SUCCESS,
    GET_ACCOUNT_RECOVERY_ERROR,
    ACCOUNT_RECOVERY_SELECTION } from '../constants/forgotpwd'
import { isSessionTimedOut } from '../utils/app-context'


export const sessionTimeout = () => ({ type: SESSION_TIMEOUT })

export const cancel = payload => ({ payload, type: CANCEL })

const validateRecoveryTokenInit = () => ({ type: INIT })
const validateRecoveryTokenFailure = payload => ({ payload, type: FETCH_DATA_ERROR })
const validateRecoveryTokenSuccess = payload => ({ payload, type: FETCH_DATA_SUCCESS })

const onSubmitPassword = payload => ({ payload, type: SUBMIT_PASSWORD })
const submitPasswordSuccess = payload => ({ payload, type: SUBMIT_PASSWORD_SUCCESS })
const submitPasswordFailure = payload => ({ payload, type: SUBMIT_PASSWORD_ERROR })

const onSubmitVerificationInit = payload => ({ payload, type: SUBMIT_VERIFICATION_INIT })
const submitVerificationInitSuccess = payload => ({ payload, type: SUBMIT_VERIFICATION_INIT_SUCCESS })
const submitVerificationInitFailure = payload => ({ payload, type: SUBMIT_VERIFICATION_INIT_ERROR })

const onSendChallenge = () => ({ type: SEND_CHALLENGE })
const submitSendChallengeSuccess = payload => ({ payload, type: SEND_CHALLENGE_SUCCESS })
const submitSendChallengeFailure = payload => ({ payload, type: SEND_CHALLENGE_ERROR })

const onVerifyAccountRecovery = payload => ({ payload, type: VERIFY_ACCOUNT_RECOVERY })
const submitVerifyAccountRecoverySuccess = payload => ({ payload, type: VERIFY_ACCOUNT_RECOVERY_SUCCESS })
const submitVerifyAccountRecoveryFailure = payload => ({ payload, type: VERIFY_ACCOUNT_RECOVERY_ERROR })

const onResendCode = payload => ({ payload, type: RESEND_CODE })
const resendCodeSuccess = payload => ({ payload, type: RESEND_CODE_SUCCESS })
const resendCodeFailure = payload => ({ payload, type: RESEND_CODE_ERROR })
export const next = () => ({ type: ON_NEXT })
export const initUserApps = () => ({ type: INIT_USER_APPS })
export const initUserAppsSuccess = payload => ({ payload, type: INIT_USER_APPS_SUCCESS })
export const initUserAppsFailure = payload => ({ payload, type: INIT_USER_APPS_ERROR })

export const getAccountRecoveryInit = () => ({ type: GET_ACCOUNT_RECOVERY })
export const getAccountRecoverySuccess = payload => ({ payload, type: GET_ACCOUNT_RECOVERY_SUCCESS })
export const getAccountRecoveryError = payload => ({ payload, type: GET_ACCOUNT_RECOVERY_ERROR })

export const accountRecoverySelection = () => ({ type: ACCOUNT_RECOVERY_SELECTION })


export const verifyAccountRecovery = body => {
    return dispatch => {
        dispatch(onVerifyAccountRecovery())

        axios.post(routesForgotpwd.verifyAccountRecovery, body)
            .then(() => dispatch(submitVerifyAccountRecoverySuccess()))
            .catch(err => dispatch(submitVerifyAccountRecoveryFailure(err.response.data.error)))
    }
}

export const sendChallenge = recoveryType => {
    return dispatch => {
        dispatch(onSendChallenge())

        axios.post(routesForgotpwd.sendChallenge, recoveryType)
            .then(result => dispatch(submitSendChallengeSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(submitSendChallengeFailure(err.response.data.error))
            })
    }
}

export const resendCode = recoveryType => {
    return dispatch => {
        dispatch(onResendCode())

        axios.post(routesForgotpwd.sendChallenge, recoveryType)
            .then(() => dispatch(resendCodeSuccess()))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(resendCodeFailure(err.response.data.error))
            })
    }
}

export const validateRecoveryToken = recoveryToken => {
    return dispatch => {
        dispatch(validateRecoveryTokenInit())

        axios.post(routesForgotpwd.verifyRecoveryToken, { recoveryToken })
            .then(result => dispatch(validateRecoveryTokenSuccess(result.data.data)))
            .catch(err => dispatch(validateRecoveryTokenFailure(err.response.data.error)))
    }
}

export const resetPassword = values => {
    return dispatch => {
        dispatch(onSubmitPassword())

        axios.post(routesForgotpwd.resetPassword, values)
            .then(result => dispatch(submitPasswordSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(submitPasswordFailure(err.response.data.error))
            })
    }
}

export const submitVerificationInit = passCode => {
    return dispatch => {
        dispatch(onSubmitVerificationInit())

        axios.post(routesForgotpwd.commit, passCode)
            .then(() => dispatch(submitVerificationInitSuccess()))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(submitVerificationInitFailure(err.response.data.error))
            })
    }
}

export const getLogins = () => {
    return dispatch => {
        dispatch(initUserApps())

        axios.get(routesForgotpwd.getLogins)
            .then(result => dispatch(initUserAppsSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(initUserAppsFailure(err.response.data.error))
            })
    }
}

export const getAccountRecovery = body => {
    return dispatch => {
        dispatch(getAccountRecoveryInit())

        axios.post(routesForgotpwd.getAccountRecovery, body)
            .then(result => dispatch(getAccountRecoverySuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(getAccountRecoveryError(err.response.data.error))
            })
    }
}
